import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link",
  "use": "link-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"link\"><path d=\"M176 246c-6 4-16 0-22-3l-90-89c-6-7-6-20 0-29l61-61c6-6 19-6 29 0l89 90c3 6 7 16 3 22l42 42c26-32 26-77-3-106l-90-90c-32-32-80-32-112 0L22 83c-32 32-32 80 0 112l90 90c29 29 77 32 106 3zm314 71l-90-90c-29-29-77-32-106-3l42 42c6-4 16-4 22 3l90 89c6 7 6 20 0 29l-61 61c-6 6-19 6-29 0l-89-90c-7-6-7-16-3-22l-42-42c-26 32-26 77 3 106l90 90c32 32 80 32 112 0l61-61c28-32 28-80 0-112zM144 144c-13 13-13 29 0 42l179 179c13 13 29 13 42 0s13-29 0-42L186 144c-13-13-32-13-42 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/link.svg
// module id = 196
// module chunks = 0